import type { RouteRecordRaw, NavigationGuardNext } from 'vue-router';
import { isEnabled, FeatureFlag } from '@client/monolith/legacy/services/features';

export const routes: RouteRecordRaw[] = [
  {
    path: 'offers-and-discounts',
    name: 'account.offers-and-discounts',
    component: () => import('./offers-and-discounts-page.vue'),
    props: false,
    beforeEnter: (_to, _from, next: NavigationGuardNext) => {
      if (isEnabled(FeatureFlag.OffersAndDiscountsPage)) {
        next();
      } else {
        next({ path: '/v2/account/dashboard' });
      }
    },
  },
];
